import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private msalService: MsalService) {}

  // Decode the JWT token and extract roles
  getUserRoles(): string[] {
    const currentAccount = this.msalService.instance.getAllAccounts()[0];
    
    if (currentAccount) {
      const idToken = currentAccount.idTokenClaims; // Extract idTokenClaims from the current account
      if (idToken && idToken.roles) {
        return idToken.roles; // Return roles array from the token
      }
    }
    return [];
  }

  // Check if the user has the required roles
  hasRequiredRoles(requiredRoles: string[]): boolean {
    const roles = this.getUserRoles();
    return requiredRoles.some(role => roles.includes(role)); // Check if any required role exists in user's roles
  }
}
